module.exports = __webpack_public_path__ + "img/CALENDAR.3e9aea1e.svg";